import { useRef, useEffect } from 'react';
import { useIsomorphicLayoutEffect } from '@shopify/react-hooks';
import { Transforms, Range } from 'slate';

function useDerivedSelection(editor, {
  onChange,
  value
}) {
  const onChangeRef = useRef(onChange);
  const lastSelectionRef = useRef(null);
  useIsomorphicLayoutEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);
  useEffect(() => {
    const {
      apply
    } = editor;
    editor.apply = operation => {
      const selection = editor.selection;
      apply(operation);
      queueMicrotask(() => {
        if (!selectionEqual(selection, editor.selection)) {
          if (lastSelectionRef.current !== editor.selection) {
            onChangeRef.current(editor.selection);
            lastSelectionRef.current = editor.selection;
          }
        }
      });
    };
  }, [editor]);
  useEffect(() => {
    if (selectionEqual(value, editor.selection)) {
      // External value for selection and editor value are in sync, no-op
      return;
    }
    if (value === null) {
      Transforms.deselect(editor);
      return;
    }
    Transforms.setSelection(editor, value);
  }, [editor, value]);
}
function selectionEqual(selection, another) {
  if (selection === another) {
    return true;
  }
  if (selection !== null && another !== null) {
    return Range.equals(selection, another);
  }
  if (selection === null && another === null) {
    return true;
  }
  return false;
}

export { useDerivedSelection };
